import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NewNotes from "./component/ec2StatusUpdate";
import SignIn from "./component/signin";

function App() {
  const token = sessionStorage.getItem("token");

  return (
    <BrowserRouter>
      <Routes>
        {token ? (
          <>
            <Route path="/" element={<NewNotes />} />
            <Route path="*" element={<NewNotes />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<SignIn />} />
            <Route path="*" element={<SignIn />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
